/**
 * Card — section container with optional title, subtitle, and header action.
 */
export function Card({ title, subtitle, children, className = "", headerAction }) {
  return (
    <div className={`bg-white rounded-lg border border-gray-200 p-6 ${className}`}>
      {(title || subtitle || headerAction) && (
        <div className="mb-4">
          <div className="flex items-center justify-between">
            <div>
              {title && <h3 className="text-lg font-semibold text-[#191919]">{title}</h3>}
              {subtitle && <p className="text-sm text-gray-600 mt-1">{subtitle}</p>}
            </div>
            {headerAction && <div>{headerAction}</div>}
          </div>
        </div>
      )}
      {children}
    </div>
  );
}

export default Card;
